import {
    ApiParameter,
    post,
    ServiceResult,
} from "@insite/client-framework/Services/ApiService";

const resetPasswordUrl = "/api/sainc/myAccount/resetPasswordRequest";


export async function resetPassword(): Promise<ServiceResult<ApiParameter>> {
    try {
        const resetPasswordModel = await post<ApiParameter>(resetPasswordUrl);
        return {
            result: resetPasswordModel,
            successful: true,
        };
    } catch (error) {
        return {
            successful: false,
            errorMessage: ((error as any)?.errorJson?.message),
        };
    }
}